//
//
//
//
//
//
//
//
//
//
//
//
//

import { routeTransitionFade } from '@/mixins/route-transitions'
import { resetCanvas } from '../static/js/createCircles.js'
export default {
  mixins: [routeTransitionFade],
  data() {
    return {
      isMobile: false,
      isDesktop: false,
    }
  },
  mounted() {
    this.$app.$emit('page::mounted')
    this.SetDeviceType()
    resetCanvas()
  },
  methods: {
    SetDeviceType() {
      const windowWidth = window.innerWidth
      if (windowWidth < 1024) {
        this.isMobile = true
      } else {
        this.isDesktop = true
      }
    },
  },
}
